export default __webpack_public_path__ + "static/media/TR-76GA-RF.82c7bd88.png";